import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import SimpleLoad from "../../loader/SimpleLoad";
import * as Yup from 'yup';
import Get from "../../api/Get";
import { APPOINTMENT_UPDATE, DISEASE_GET_ALL, DISEASE_GET_ALL_NEW, TIPO_DIAGNOSTICO_ALL_ACTIVE } from "../../api/Routes";
import Put from "../../api/Put";
import SelectAjaxDiagnostico from "../diagnostico/SelectAjaxDiagnostico";


function ModalDiagnosticoColombia({t, citaID, show, setDiagnosticos, setShow, idSpeciality, auth, setShowModalError, setErrorServer}){
    const [diagnostico, setDiagnostico] = useState()
    const [options, setOptions] = useState([])
    const [tipoOpt, setTipoOpt] = useState([]) 
    
     //diagnosticos
     const [mainDiagnosticosOpt, setMainDiagnosticosOpt] = useState([])

    const handleClose = () => setShow(false);
    const [initialValues, setInitialValues] = useState({
        disease : '',
        diseaseType: ''
    })
    const shemaValidate = Yup.object().shape({
        disease : Yup.number().required(t('Camporequerido')),
        diseaseType : Yup.number().required(t('Camporequerido')),
    });

    useEffect(() => {
        let mounted = true
        Get({url: `${DISEASE_GET_ALL}/${idSpeciality}`, access_token: auth.data.access_token})
        .then(response=>{
            //console.log(response)
            if(mounted){
                setOptions(response.data.data.response.content.map(ele=>({value: ele.id, label: `${ele?.code4digits} - ${ele?.description}`})))
            }
            
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })

        Get({url: TIPO_DIAGNOSTICO_ALL_ACTIVE, access_token: auth.data.access_token})
        .then(response=>{
            setTipoOpt(response.data.data.response)
        })
        .catch(error=>{
            setShowModalError(true)
            if(error.response){
                setErrorServer(error.response)
            }
        })
        return () => mounted = false;
    }, [])

     //principales diagnosticos
     const fetchMainDiagnosticosApi = async () => {
        try {
            const response = await Get({url : `${DISEASE_GET_ALL_NEW}/0/20000/id/asc/false/%20`, access_token: auth.data.access_token})
            if(response.data.state){
                setMainDiagnosticosOpt(response.data.data.response.content.map((ele) => ({value: ele.id, label: `${ele?.code4digits} - ${ele?.description}`})))
            }
            console.log(response)
        } catch (error) {
            console.log(error)
        }   
    }

    useEffect(() => {
        fetchMainDiagnosticosApi()
    }, [])

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header closeButton>
            <Modal.Title className="text-dark">{t('diagnostico')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik initialValues={ initialValues }
                    validationSchema={shemaValidate}
                    onSubmit={(values, { setSubmitting, setFieldValue, resetForm }) => { 
                        let data = {
                            id:citaID,
                            diseaseList: [
                                {
                                  disease: { id: values.disease },
                                  diseaseType: { id: parseInt(values.diseaseType)},
                                  id: null
                                }
                            ]
                        }                        
                        Put({url: APPOINTMENT_UPDATE, data: data, access_token: auth.data.access_token, header: true})
                        .then(resp => {
                            setSubmitting(false)
                            resetForm({
                                values: {
                                    disease: '',
                                    diseaseType: ''
                                }
                            })
                            setDiagnostico(null)
                            setDiagnosticos(resp.data.data.diseaseList)
                            handleClose()
                        })
                        .catch(error => {
                            setSubmitting(false)
                            setShowModalError(true)
                            if(error.response){
                                setErrorServer(error.response)
                            }
                        })
                    }}>{({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        resetForm
                    })=>(
                        <Form onSubmit={handleSubmit}  className='mt-3 position-relative'>
                            { isSubmitting && <SimpleLoad /> }
                            <Row>
                                <Col xs="12" md="12">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary"> {t('diagnostico')} </Form.Label>
                                        <SelectAjaxDiagnostico
                                            defaultValue={diagnostico}
                                            value={diagnostico}
                                            url={`${DISEASE_GET_ALL_NEW}/0/20000/id/asc/true/%20`}
                                            access_token={auth.data.access_token}
                                            isMulti={false}
                                            handleChange={(item) => {
                                                setDiagnostico(item)
                                                setFieldValue("disease",item?.value)
                                            }} 
                                            defaultOptions={mainDiagnosticosOpt}   
                                            valid={true}     
                                            isClearable={false}
                                            className='react-select-input' 
                                            placeholder={'Seleccionar...'}
                                            idSpeciality={idSpeciality}
                                        />
                                        { errors.disease && <div className="invalid-feedback d-block">{errors.disease}</div> }
                                    </Form.Group>
                                </Col>
                                <Col xs="12" md="12">
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold-600 text-secondary"> {t('tipo')} </Form.Label>
                                        <Field
                                            className={`form-control input-form ${errors.diseaseType && 'error'}`}
                                            name="diseaseType"
                                            as="select"
                                        >
                                            <option value=''>{t('Seleccionar')}</option>
                                            {
                                                tipoOpt.map((item,i)=>(
                                                    <option key={i} value={item.id}>{item.name}</option>
                                                ))
                                            }
                                        </Field>
                                        { errors.diseaseType && <div className="invalid-feedback d-block">{errors.diseaseType}</div> }
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="grupoBotones">
                                <Col className="text-right">
                                    <Button variant="outline-success" className="ok-buttom" type="submit"> {t('guardar')} </Button>{' '}
                                </Col>
                            </Row>
                        </Form>
                    )}
                    </Formik>
            </Modal.Body>
        </Modal>
    )
}

export default withTranslation()(ModalDiagnosticoColombia)